import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

export interface DeleteScheduleOrItemsPayload {
  scheduleId: number;
  narrative: string;
  locationGroupId?: number | string;
  scheduleItemId?: number;
}

export const useDeleteScheduleOrItems = () => {
  return useMutation({
    mutationFn: deleteScheduleOrItems,
    onSuccess: async (data, variables) => {
      await queryClient.refetchQueries(queryKeys.components.invalidateAll());
      await queryClient.refetchQueries(
        queryKeys.scheduleOverview.invalidateAll(),
      );
      await queryClient.refetchQueries(queryKeys.scheduleList.invalidateAll());
      await queryClient.refetchQueries(
        queryKeys.componentListing.invalidateAll(),
      );
      await queryClient.refetchQueries(
        queryKeys.getCalendarEvents.invalidateAll(),
      );
      await queryClient.invalidateQueries(
        queryKeys.getCalendarSidebarDetails.invalidateAll(),
      );
      queryClient.removeQueries(
        queryKeys.schedules.details(variables.scheduleId.toString()),
      );
      await queryClient.refetchQueries(queryKeys.schedules.invalidateAll());
    },
  });
};

export const deleteScheduleOrItems = ({
  scheduleId,
  scheduleItemId,
  narrative,
}: DeleteScheduleOrItemsPayload) => {
  const queryParts: string[] = [
    `schedule_id=${scheduleId}`,
    ...(scheduleItemId ? [`schedule_item_id=${scheduleItemId}`] : []),
    ...(narrative ? [`narrative=${encodeURIComponent(narrative)}`] : []),
  ];

  const url = `/schedules${generateQuery([], queryParts)}`;

  return requestCCApi({ url, method: 'DELETE' });
};
